import { OrbitControls } from '@react-three/drei'
import { Perf } from 'r3f-perf'
import Track from './Components/Track/Track.tsx'
import Runner from './Components/Runner/Runner.tsx'

interface Props {
    distance: number,
    lane: number,
    timePerKm : string,
    time: number,
    isPlay: boolean,
    setPlay: React.Dispatch<SetStateAction<boolean>>,
    cameraLocked : boolean,
}

const Experience = ({distance, lane, time, timePerKm, isPlay, cameraLocked, setPlay}: Props): React.JSX.Element => {

  return (
    <>
      {/* <Perf position="top-left" /> */}
      <OrbitControls />
      <directionalLight position={[1,2,3]} intensity={1.5} />
      <ambientLight intensity={1.5} />
      <Track/>
      <Runner cameraLocked={cameraLocked} timePerKm={timePerKm} distance={distance} lane={lane} time={time} isPlay={isPlay} setPlay={setPlay} />
    </>
  )
}

export default Experience;